import Main from '@/components/main/Main';
// 支付模块的路由
const dmpRoutes = [
  // {
  // name: 'building',
  // path: '/building',
  // component: Main,
  // redirect: '/building/buildinginfo',
  // meta: {
  //   showInMenu: true,
  //   showAlways: true, // 表示一定要展示子菜单
  //   title: '楼宇管理',
  //   icon: 'ios-apps'
  // },
  // children: [
  //   {
  //     name: 'building_park',
  //     path: 'park',
  //     component: () => import('@/emc-building/views/park'),
  //     meta: {
  //       showInMenu: true,
  //       path: '/building/park',
  //       title: '疗区管理',
  //       icon: 'logo-apple'
  //     }
  //   }
  // ]
  // }
];

export default dmpRoutes;
